import React from 'react';
import { get, map, find } from 'lodash';
import { Icon } from 'modules/icon-bank';

//local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';
import { getLabel } from 'utils/getLabel';
import { getDisplayValue } from 'resolvers/formatValue';
import { DATA_TYPES } from 'constants/common';

import { DetailSummaryAction } from 'ui/views/widgets/memberOrderDetailSummary';

/************************************* */
const NAV_ACTION_ICON = {
	'createClaimToDo': 'checkedContent',
};

/************************************* */


//  Success view
export const memberClaimDetailSummarySuccess = ( props ) => {

    // fetching data from the props
	const fields = get( props, 'componentData.fields', [] );
	const pharmacyInfo = find( get( props, 'componentData.sections', [] ), {
		type: 'pharmacyInfo',
	} );
	const claimantInfo = find( get( props, 'componentData.sections', [] ), {
		type: 'claimantInfo',
	} );
	const costInfo = find( get( props, 'componentData.sections', [] ), {
		type: 'costInfo',
	} );
	const widgetTitle = get( props, 'componentData.widgetConfig.title',  {} );
	const claimData = get( props, 'componentData.claimData',  {} );

	const summaryActions = get( props, 'componentData.summaryActions', [] );

	return (
		<div className='ui-member-claim-detail-summary'>
			
			{ /* widget title */ }
            <div className='ui-member-claim-detail-summary__header'>
				<div className='ui-member-claim-detail-summary__header__title'>
					{ getLabel( widgetTitle ) }
				</div>
               

				<div className='ui-member-order-detail-summary__header__actions'>
                    { map( summaryActions, action => {

                        // get if the action is active or not
                        // const isActive = get( action, `actionsVisibility.${ action.visibility }`, false );

                        // get action icon
                        const iconName = NAV_ACTION_ICON[ `${ action.name }` ];

                        return (
                            <DetailSummaryAction
                                key={ action.name }
                                action={ action }
                                isActive={ true }
                                iconName={ iconName }
                                onClick={ props.onActionClick }
                            />
                        );

                    } ) }
                </div>
            </div>
			<div className='ui-member-claim-detail-summary__body'>

				{ /* view to render claim details */ }
				<div className='ui-member-claim-detail-summary__body__primary'>
                    
					<EntityInfoCells
						items={ fields }
						values={ claimData.claimDetails }
						actionsVisibility={ claimData.actionsVisibility.fieldActions }
						onActionClick={ props.onActionClick }
						className='ui-member-claim-detail-summary__body__primary__cell'
					/>

				</div>
				{ /* pharmacy and claimant details */ }
				<div className='ui-member-claim-detail-summary__body__secondary'>
					{ /* pharmacy details */ }
					<div className='ui-member-claim-detail-summary__body__secondary__table'>
                        <div className='ui-member-claim-detail-summary__body__secondary__table__icon' >
							<Icon name='drug' />
                        </div>
                        <div className='ui-member-claim-detail-summary__body__secondary__table__data'>
                            <EntityInfoCells
                                items={ pharmacyInfo.fields }
                                values={ claimData.pharmacyDetails }
                                actionsVisibility={ claimData.actionsVisibility }
                                onActionClick={ props.onActionClick }
                                className='ui-member-claim-detail-summary__body__secondary__table__data__cell'
                            />
                        </div>
					</div>
					{ /* Claimant details */ }
					<div className='ui-member-claim-detail-summary__body__secondary__table'>
                        <div className='ui-member-claim-detail-summary__body__secondary__table__icon'>
                            <Icon name='claimant' />
                        </div>
                        <div className='ui-member-claim-detail-summary__body__secondary__table__data'>
                            <EntityInfoCells
                                items={ claimantInfo.fields }
                                values={ claimData.claimantDetails }
                                actionsVisibility={ claimData.actionsVisibility }
                                onActionClick={ props.onActionClick }
                                className='ui-member-claim-detail-summary__body__secondary__table__data__cell'
                            />
                        </div>
					</div>
				</div>
				{ /* cost details */ }
				<div className='ui-member-claim-detail-summary__body__additional'>
					<div className='ui-member-claim-detail-summary__body__additional__total-cost'>
						<div className='ui-member-claim-detail-summary__body__additional__total-cost__title'>
							{ getLabel( find( costInfo.fields, { name: 'totalCost' } ).title ) }
						</div>
						<div className='ui-member-claim-detail-summary__body__additional__total-cost__value'>
                            { ' : ' }{ getDisplayValue( {
								type: DATA_TYPES.CURRENCY,
								value: claimData.cost.totalCost,
							} ) }
						</div>
					</div>
					<div className='ui-member-claim-detail-summary__body__additional__cost'>
						<div className='ui-member-claim-detail-summary__body__additional__cost__plan-paid'>
							<div className='ui-member-claim-detail-summary__body__additional__cost__plan-paid__title'>
								{ getLabel( find( costInfo.fields, { name: 'planPaid' } ).title ) }
							</div>
							<div className='ui-member-claim-detail-summary__body__additional__cost__plan-paid__value'>
                                { ' : ' }{ getDisplayValue( {
									type: DATA_TYPES.CURRENCY,
									value: claimData.cost.planPaid,
								} ) }
							</div>
						</div>
						<div className='ui-member-claim-detail-summary__body__additional__cost__member-paid'>
							<div className='ui-member-claim-detail-summary__body__additional__cost__member-paid__title'>
								{ getLabel( find( costInfo.fields, { name: 'memberPaid' } ).title ) }
							</div>
							<div className='ui-member-claim-detail-summary__body__additional__cost__member-paid__value'>
                                { ' : ' }{ getDisplayValue( {
									type: DATA_TYPES.CURRENCY,
									value: claimData.cost.memberPaid,
								} ) }
							</div>
						</div>
					</div>
					<div className='ui-member-claim-detail-summary__body__additional__message'>
						{ getLabel( costInfo.sectionConfig.additionalInfo ) }
					</div>
				</div>
			</div>
		</div>
	);
 };

// set display name
memberClaimDetailSummarySuccess.displayName = 'memberClaimDetailSummarySuccess';

// set default props
memberClaimDetailSummarySuccess.defaultProps =  {};

// prop types
memberClaimDetailSummarySuccess.propTypes =  {};

/*************************************************************** */
//  preloader view
export const memberClaimDetailSummaryPreloader = () => {
	return (
        <div className='ui-member-claim-detail-summary-preloader'>
        <div className='ui-member-claim-detail-summary-preloader__header'>
            <div className='ui-member-claim-detail-summary-preloader__header__title'></div>
        </div>
        <div className='ui-member-claim-detail-summary-preloader__body'>
            { map( [ 1, 2 ], item => {
                return (
                    <div className='ui-member-claim-detail-summary-preloader__body__primary' key={ item }>
                        { map( [ 1, 2, 3, 4, 5, 6 ], _item => {
                            return (
                                <div  className='ui-member-claim-detail-summary-preloader__body__primary__cell' key={ _item }>
                                    <div className='ui-member-claim-detail-summary-preloader__body__primary__cell__title'></div>
                                    <div className='ui-member-claim-detail-summary-preloader__body__primary__cell__value'></div>
                                </div>
                            );
                        } ) }
                    </div>
                );
            } ) }
        </div>
    </div>
	);
 };

// set display name
memberClaimDetailSummaryPreloader.displayName =
	'memberClaimDetailSummaryPreloader';

// set default props
memberClaimDetailSummaryPreloader.defaultProps =  {};

// prop types
memberClaimDetailSummaryPreloader.propTypes =  {};

/************************************************** */

/**
 * @type { object }
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberClaimDetailSummary as MemberClaimDetailSummary } from 'ui/views/widgets/memberClaimDetailSummary';
 *
 * // render
 * <MemberClaimDetailSummary propName='propValue'/>
 */

export const memberClaimDetailSummary = withNetworkState( memberClaimDetailSummaryPreloader, memberClaimDetailSummarySuccess );
